import { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { addJsScriptSync, FoundationsRequest, getBaseUrl, getUrlVars, toBinary } from '../../Utils'
import { FormFrame } from './formsEngineFrame'
import { formHelp } from './formHelpers'
import { fieldReducer, FormActionKind, formReducer } from './formReducer'
import FormEngineContext, { useFormEngineContext } from './formContext'
import { FormStatusCompo } from './formStatusCompo'
import { LeftTables } from './LeftTables'
import { BarCodeSection, PHIHeader, ReadOnlyFormSection } from './ReadOnlySection'
import { formNavigation } from './formNavigation'
import { API, FormButtons } from './formComponents'
import { set } from 'react-hook-form'
import { ActionsSection } from './ActionsSection'
import { UpdateFormSection } from './updateFormSection'
import { FormMetaData, FormSchemaMetaData, MetaDataMap } from './formInterfaces'
import React from 'react'
import moment from 'moment'
import FieldContext, { useFieldContext } from './fieldInstanceContext'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import Cookies from 'js-cookie'
import { checkType1, checkUserPrivileges, setCookie } from '../../GlobalMethods'
import { useSelector } from 'react-redux'
import { getAppSettings, getCurrentUserData, RootState } from '../../Redux/store'
import { getWorkspaceData } from '../../Redux/Workspace/workspaceSlice'
import OCVDialog from '../../Components/OCV/OCVDialog'
import { ObjectContext } from '../../Components/OCV/OCVTypes'
import Dialog from '../../GenericComponents/dialog'
import HandleAnyPopupMessage from '../../Components/handleAnyPopupMessage'
import { toast } from 'react-toastify'
import { FoundationsConstants } from '../../FoundationsConstants'
import IdleWatcher from '../../Hooks/idleWatcher'
import { setTime } from 'react-datepicker/dist/date_utils'
import { useTitleContext } from '../../Hooks/useTitleContext'
declare let window: any

const FormsEngine: React.FC = () => {
    const { setTitle } = useTitleContext();
    setTitle("Forms Engine");
    const formName = getUrlVars()['formName']
    const metaFormName = getUrlVars()['formName']
    const navigationenabled = getUrlVars()['navigationenabled']
    const drillThruParams = getUrlVars()['drillThruParams']
    const [commentsAudit, setCommentsAudit] = useState('')
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const appSettings: any = useSelector((state: RootState) => {
        return getAppSettings(state)
    })
    const addAuditComment = useCallback((newComment: string) => {
        setCommentsAudit(commentsAudit + newComment)
    }, [])
    const [formState, formDispatch] = useReducer(formReducer, {
        dataObjectId: getUrlVars()['dataObjectId'],
        isNavigationEnabled: 'false',
        guid: getUrlVars()['guid'],
        tabGuid: getUrlVars()['guid'],
        addAuditComment: addAuditComment,
        schema: {} as FormSchemaMetaData,
        templateType: '',
        MetaDataMap: {} as MetaDataMap,
        validatorMetaMap: {},
    })
    const [fieldState, fieldDispatch] = useReducer(fieldReducer, {
        fieldInstances: undefined,
    })
    const formProviderState = {
        formState,
        formDispatch,
    }

    const fieldProviderState = {
        fieldState,
        fieldDispatch,
    }

    // =================== TODO combine into reducer ? don't mix state reducer and context? ===================
    const [loading, setLoading] = useState(true)
    const [formExists, setFormExists] = useState(false)
    const [userHasPermission, setUserHasPermission] = useState(false)
    const [sectionDetailsLoaded, setSectionDetailsLoaded] = useState(false)
    const [isReadonlySectionLoaded, setIsReadonlySectionLoaded] = useState(false)
    const [readOnlySectionApiCallCount, setReadOnlySectionApiCallCount] = useState(0)
    // const [isNavigationEnabled = false;
    // const [$app_ajax_page_message_popup = $("#app_ajax_page_message_popup");

    // subVizList appears to not be used, it is always set to true
    // const [subVizList, setSubVizList] = useState([] as boolean[])

    const [showEditBtn, setShowEditBtn] = useState(false)
    const [hindex, setHindex] = useState(-1)
    const [bannerObj, setBannerObj] = useState({ color: 'white', component: [] })
    const [headerObj, setHeaderObj] = useState({ component: [] })
    const [barCodeObj, setBarCodeObj] = useState({ component: [] })
    const [leftTableList, setLeftTableList] = useState([] as { [s: string]: any }[])
    const [centerTableList, setCenterTableList] = useState([] as { [s: string]: any }[])
    const [buttonList, setButtonList] = useState([] as { [s: string]: any }[])
    const [reportStatus, setReportStatus] = useState('')
    const [lastUpdatedBy, setLastUpdatedBy] = useState('')
    const [lastUpdatedOn, setLastUpdatedOn] = useState('')
    const [pdfName, setPdfName] = useState('')
    const [statusId, setStatusId] = useState(-99)

    const [formComments, setFormComments] = useState('')
    const [highlightComment, setHighlightComment] = useState(false)
    const [saveText, setSaveText] = useState('Save')
    const [oldFormData, setOldFormData] = useState([])
    // const [formCounter, setFormCounter] = useState(-1)
    // const [startTimer, setStartTimer] = useState(false)
    // TODO handle this in the correct way, don't store the toastr window in state

    const [showFieldId, setShowFieldId] = useState(false)
    const isFormLocked = useRef(false)
    const [formActions, setFormActions] = useState({
        AllowProtocolFormApprove: false,
        AllowClinicalReportsEdit: false,
        AllowClinicalReportsView: false,
    } as { [s: string]: boolean })

    const [printedOn, setPrintedOn] = useState(moment(Date.now()).format('MM/DD/YYYY hh:mm A'))
    const [dialogVisible, setDialogVisible] = useState(false)
    const [dialogObject, setDialogObject] = useState({} as ObjectContext)
    const drillThruObjRef = useRef(undefined as undefined | { [s: string]: any })
    const globalTabGuidRef = useRef('' as string | undefined)

    const [showPopupMessage, setShowPopupMessage] = useState(false)
    const [popupTitle, setPopupTitle] = useState('')
    const [popupMessage, setPopupMessage] = useState('')
    const [hidePopupClose, setHidePopupClose] = useState(false)
    const [closeAfterSecs, setCloseAfterSecs] = useState(undefined as number | undefined)
    const [customPopupButtons, setCustomPopupButtons] = useState(
        [] as { text: string; onClick: () => void }[]
    )
    const setPopUpInfo = useCallback(
        (
            title: string,
            message: string,
            hideClose: boolean,
            timer: number,
            buttons: { text: string; onClick: () => void }[]
        ) => {
            setPopupTitle(title)
            setPopupMessage(message)
            setHidePopupClose(hideClose)
            setCloseAfterSecs(timer)
            setCustomPopupButtons(buttons)
        },
        []
    )

    formHelp.checkandset_Issingletoncookies(window.location.href) //FP-5973 Adding check and set cookies for singelton forms on form launching.
    // =================== End TODO ===========================================================================
    const setTabGuid = (newGuid: string) => {
        globalTabGuidRef.current = newGuid
    }
    // =================== Session Info =====================================================

    // const sessionInterval = useRef<NodeJS.Timeout | null>(null)
    const timerToastId = useRef<string | number | null>(null)
    // const checkFormSession = () => {
    //     //clear existing timeouts
    //     if (formCounter > -1) {
    //         setFormCounter(-1)
    //         timerToastId.current = null
    //     }
    //     setStartTimer(!startTimer)
    //     setFormCounter(currentFormCount)

    //     sessionInterval.current = setInterval(function () {
    //         if (sessionStorage.getItem('formLockGuid') != undefined) {
    //             //only update when needed to avoid unnecessary rerenders
    //             if (!formState.lockedStatus){
    //                 formDispatch({
    //                     type: FormActionKind.setLockedStatus,
    //                     payload: true,
    //                 })
    //             }
    //             var formExpirationTime = appSettings.formsLockTimeOut || -1
    //             var counter = Math.round(
    //                 formExpirationTime * 60 -
    //                     Math.abs((Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) / 1000)
    //             )
    //             var extendSession =
    //                 Math.round(Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION)) / 1000) >=
    //                 Math.round(Number(Date.now() / 1000))
    //             if (isFormLocked.current && extendSession) {
    //                 isFormLocked.current = false
    //                 extendFormSession(false, false)
    //             }

    //             //    if ($("#toast-container").length) {
    //             //        if (!$("#toast-forms").length) {
    //             //            $(".toast").append("<div id='toast-forms'></div>");
    //             //        }
    //             //    }

    //             if (counter <= 30) {
    //                 isFormLocked.current = true
    //                 if (Cookies.get(FoundationsConstants.LAST_USER_INTERACTION)) {
    //                     if (!timerToastId.current) {
    //                         timerToastId.current = FoundationsGenericToaster(
    //                             'error',
    //                             formHelp.getFormsPopupMessageCounter(counter),
    //                             { autoClose: 0 }
    //                         )
    //                     } else {
    //                         if (timerToastId.current !== null) {
    //                             toast.update(timerToastId.current, {
    //                                 render: formHelp.getFormsPopupMessageCounter(counter),
    //                                 type: 'error',
    //                             })
    //                         }
    //                     }
    //                 }

    //                 var idleAllowedTime = (formExpirationTime - 2) * 60
    //                 if (
    //                     !Cookies.get(FoundationsConstants.LAST_USER_INTERACTION) ||
    //                     Math.abs(
    //                         (Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) / 1000
    //                     ) < idleAllowedTime
    //                 ) {
    //                     if (timerToastId.current !== null) toast.dismiss(timerToastId.current)
    //                     if (sessionInterval.current !== null) clearInterval(sessionInterval.current)
    //                 } else {
    //                     var counter = Math.round(
    //                         formExpirationTime * 60 -
    //                             Math.abs(
    //                                 (Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) /
    //                                     1000
    //                             )
    //                     )
    //                     if (
    //                         Math.abs(
    //                             (Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) / 1000
    //                         ) >
    //                         formExpirationTime * 60 - 5
    //                     ) {
    //                         if (timerToastId.current !== null) toast.dismiss(timerToastId.current)
    //                         if (sessionInterval.current !== null)
    //                             clearInterval(sessionInterval.current)
    //                         var customMessage = ''
    //                         var autoNav = false
    //                         if (
    //                             formState.isNavigationEnabled == 'true' &&
    //                             !formState.isCopyPasted
    //                         ) {
    //                             customMessage =
    //                                 'Click OK to re-lock this form (if not yet locked by another user) or to navigate to the next available form.'
    //                             autoNav = true
    //                         } else {
    //                             customMessage =
    //                                 'Click OK to re-lock this form (if not yet locked by another user). Otherwise it will load as read-only.'
    //                             autoNav = false
    //                         }
    //                         var msg = customMessage
    //                         formDispatch({
    //                             type: FormActionKind.setLockedStatus,
    //                             payload: false,
    //                         })
    //                         checkOrGetLock()
    //                         setPopUpInfo('Form Time Out', msg, true, -1, [
    //                             {
    //                                 text: 'ok',
    //                                 onClick: () => {
    //                                     extendFormSession(true, autoNav)
    //                                 },
    //                             },
    //                         ])
    //                         setShowPopupMessage(true)
    //                     } else {
    //                         //    if ($("#session-popup").length)
    //                         //        $("#toast-forms").html(App.getFormsPopupMessageCounter(counter));
    //                         //    else $(".toast-message").html(App.getFormsPopupMessageCounter(counter));
    //                         if (!timerToastId.current) {
    //                             timerToastId.current = FoundationsGenericToaster(
    //                                 'error',
    //                                 formHelp.getFormsPopupMessageCounter(counter),
    //                                 { autoClose: 0 }
    //                             )
    //                         } else {
    //                             if (timerToastId.current !== null)
    //                                 toast.update(timerToastId.current, {
    //                                     render: formHelp.getFormsPopupMessageCounter(counter),
    //                                     type: 'error',
    //                                 })
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }, 500)
    // }

    const extendFormSession = function (isExpired: boolean, autoNav: boolean) {
        // TODO check if need to close dialog
        // $('#session_yes').prop('disabled', true);
        // if ($app_ajax_page_message_popup.hasClass("ui-dialog-content")) {
        //     $app_ajax_page_message_popup.dialog('close');
        // }
        setShowPopupMessage(false)
        let promiseLock = new Promise(function (resolve, reject) {
            resolve(checkOrGetLock())
        })
        if (isExpired) {
            try {
                promiseLock.then((response: any) => {
                    // TODO handle jquery
                    // $('#session_yes').prop('disabled', false)
                    if (response != null) {
                        if (response.statusMessage != 'Success') {
                            console.error(
                                '*ERR* Failed to checkOrGetLock /Lock ' + response.statusMessage
                            )
                        } else {
                            let lockedData = response.data
                            if (lockedData.formLocked) {
                                //locked by You
                                sessionStorage.setItem('formLockGuid', lockedData.LockGuid)

                                // TODO handle dialog popup cleanup
                                // let $app_ajax_page_message_popup = $("#app_ajax_page_message_popup");
                                // $app_ajax_page_message_popup.dialog('close');
                                // $("#session-popup").remove();
                                // session_popup = null;
                                // checkFormSession()
                            } else {
                                if (autoNav) {
                                    let _drillThruParams = ''
                                    //    if (_drillThruObj == null) {
                                    //        _drillThruObj = JSON.parse(App.Foundations.fromBinary(healthLevelGlobal.getUrlVars()["drillthruObj"]));
                                    //    }
                                    if (drillThruObjRef.current == undefined) {
                                        FoundationsGenericToaster('error', 'Form data missing')
                                    } else {
                                        _drillThruParams = toBinary(
                                            JSON.stringify(drillThruObjRef.current)
                                        )
                                        // TODO -> migrate Foundations.WorklistNavigation.js to a file
                                        formNavigation.navigateThroughWorklist(
                                            {
                                                direction: 'forward',
                                                drillthruObj: _drillThruParams,
                                                columnsData: drillThruObjRef.current?.columnsData,
                                            },
                                            formName,
                                            formState.dataObjectId,
                                            setTabGuid,
                                            (obj: any) => {
                                                drillThruObjRef.current = obj
                                            },
                                            setPopUpInfo,
                                            setShowPopupMessage
                                        )
                                    }
                                } else {
                                    window.location.reload()
                                }
                            }
                        }
                    }
                })
            } catch (err) {
                console.error(err)
            }
        } else {
            promiseLock.then(function (response: any) {
                if (response != null) {
                    if (response.data.formLocked) {
                        // TODO handle jquery
                        // $('#session-popup').remove()
                        // FoundationsGenericToaster('clear')
                        sessionStorage.setItem('formLockGuid', response.data.LockGuid)
                        // TODO handle session_popup
                        // session_popup = null;
                        // checkFormSession()
                    }
                }
            })
        }
    }

    const checkOrGetLock = () => {
        const formLockGuid =
            sessionStorage.getItem('formLockGuid') !== null
                ? sessionStorage.getItem('formLockGuid')
                : ''

        return FoundationsRequest('POST', {
            url: getBaseUrl() + 'API/v3/FORMENGINE/Lock',
            cache: false,
            // TODO!!! set headers hjere
            includeTokenHeader: true,
            headers: {
                authtoken: window.authtoken,
                formLockGuid: formLockGuid || '',
                formName: formName,
                dataObjectId: formState.dataObjectId,
                LockedStatus: formState.lockedStatus,
                section: 200,
            },
            data: {},
            // Content-Type: "application/json",
            // dataType: "json",
            success: function (response: { statusCode: number; data: any }) {
                if (response.statusCode != 401) {
                    let lock = response.data
                    if (lock.formLocked) {
                        sessionStorage.setItem('formLockGuid', lock.LockGuid)
                    }
                }
            },
            error: function (request: any, err: any) {
                // window.healthLevelGlobal.handleAjaxPageError(request, err)
                console.error(err)
            },
        })
    }

    const unlockOnPageRedirect = () => {
        //event listener function to release lock on form tab close/browser close
        formHelp.unlockForm(
            formName,
            formState.dataObjectId,
            formState.isNavigationEnabled,
            !!formState.isCopyPasted,
            'NO',
            drillThruObjRef.current || {},
            setTabGuid,
            (obj: any) => {
                drillThruObjRef.current = obj
            },
            setPopUpInfo,
            setShowPopupMessage
        )
        formHelp.checkandremove_Issingletoncookies('', '') //FP-5973 Adding call to remove singelton info from cookies before close or refresh the page.
        removeEventListener('beforeunload', unlockOnPageRedirect)
    }

    const signin = () => {
        if (!!currentUserData && checkType1(currentUserData)) {
            setShowFieldId(true)
            setShowEditBtn(true)
        }
        if (!!currentUserData && checkUserPrivileges(currentUserData, 'AllowClinicalReportAddendum')) {
            setShowEditBtn(true)
        }

        if (formActions.AllowClinicalReportsEdit || formActions.AllowClinicalReportsView) {
            setUserHasPermission(true)

            // Wait to add the schema to the context because isSmartForm changes the strucutre of the schema
            // (this is why we have a window.schemataFormMap reference here)
            const currentSchema = JSON.parse(
                JSON.stringify(
                    window.schemataFormMap?.schemataMap[formState.templateType][metaFormName]
                )
            )
            const metaData = formState.MetaDataMap
                ? formState.MetaDataMap[formState.templateType]
                : {}
            const brokenSchema = formHelp.isSmartForm(currentSchema, metaData)
            if (brokenSchema.length < 1) {
                const dataContext = getDataContext()

                // Load Foundations data into the form
                formDispatch({
                    type: FormActionKind.setSchema,
                    payload: currentSchema,
                })
                window.addEventListener('beforeunload', unlockOnPageRedirect) //event listener to release lock on form tab close/browser close
                window.addEventListener('hashchange', () =>
                    formHelp.checkandremove_Issingletoncookies(formName, dataContext.dataObjectId)
                ) //FP-9910 event listener to remove cookies of singleton form on hash change.
            } else {
                alert(brokenSchema)
            }
        } else {
            setUserHasPermission(false)
        }
        setLoading(false)
    }

    const updateLockedStatus = (lockedData: any, dataObjectId: string) => {
        if (lockedData.formLocked && !formState.isReadOnly && lockedData.isGlobal) {
            //FP-8837 If form is not global then it should not start session for the form.
            formDispatch({
                type: FormActionKind.setLockedStatus,
                payload: true,
            })
            formDispatch({
                type: FormActionKind.setLockedStatusMsg,
                payload: 'Form is locked by you',
            })
            sessionStorage.setItem('formLockGuid', lockedData.LockGuid + '')
            // checkFormSession() //initialize the form session watcher
        } else {
            formDispatch({
                type: FormActionKind.setLockedStatus,
                payload: false,
            })
            if (formState.isReadOnly) {
                formDispatch({
                    type: FormActionKind.setLockedStatusMsg,
                    payload: 'Form Archived',
                })
            } else if (lockedData.isGlobal) {
                //FP-8837 added check of isGlobal, if form is not global then we will not show locked by popup to another user hence we are removing Lock from peerreview.
                formDispatch({
                    type: FormActionKind.setLockedStatusMsg,
                    payload: 'Form is locked by ' + lockedData.LockedByUser + '.',
                })
                if (formState.isNavigationEnabled == 'true' && !formState.isCopyPasted) {
                    const msg = 'Form is locked. Proceed to next form?'
                    setPopUpInfo('Form is Locked', msg, false, -1, [
                        {
                            text: 'yes',
                            onClick: () => {
                                formNavigation.navigateToNextForm(
                                    formState.isNavigationEnabled,
                                    formState.isCopyPasted,
                                    formName,
                                    dataObjectId,
                                    drillThruObjRef.current,
                                    setTabGuid,
                                    (obj: any) => {
                                        drillThruObjRef.current = obj
                                    },
                                    setPopUpInfo,
                                    setShowPopupMessage
                                )
                            },
                        },
                        {
                            text: 'no',
                            onClick: () => {
                                setShowPopupMessage(false)
                            },
                        },
                    ])
                    setShowPopupMessage(true)
                }
            }
        }
    }

    const getSectionDetails = (dataObjectId: string) => {
        const formLockGuid =
            sessionStorage.getItem('formLockGuid') != undefined
                ? sessionStorage.getItem('formLockGuid') + ''
                : ''
        const endpointUrl = getBaseUrl() + 'API/v3/FORMENGINE/GetFormData'
        FoundationsRequest('GET', {
            url: endpointUrl,
            includeTokenHeader: true,
            headers: {
                dataObjectId: dataObjectId,
                formName: formName,
                formLockGuid: formLockGuid,
            },
            success: function (response: {
                statusCode: number
                data: {
                    formLocked: boolean
                    isGlobal: any
                    IsSingleton: boolean
                    FormName: any
                    LockGuid(arg0: string, LockGuid: any): unknown
                    LockedByUser: string
                    FormFields: any
                    length: number
                }
                statusMessage: string
            }) {
                setSectionDetailsLoaded(true)
                if (response.data == null) {
                    console.error(
                        '/API/v3/FORMENGINE/GetFormData sent data = null. Check Security codes.'
                    )
                }

                if (!response.data.FormFields) {
                    console.error(
                        '*ERR* dataObjectId ' + dataObjectId + ' section 1 has no data field!'
                    )
                } else if (response.data.length === 0) {
                    console.error(
                        '*ERR* dataObjectId ' + dataObjectId + ' has NO field item in section 1'
                    )
                }
                if (response.statusCode === 200) {
                    const metaSection = formState.schema?.sections[0]
                    const formSection = formState.schema?.sections[0]
                    if ((performance.getEntriesByType('navigation')[0] as any).type != 'reload') {
                        sessionStorage.setItem('isCopyPasted', (document.referrer == '') + '')
                    }
                    formDispatch({
                        type: FormActionKind.setIsCopyPasted,
                        payload: JSON.parse(sessionStorage.getItem('isCopyPasted') || ''),
                    })
                    if (formState.isCopyPasted) {
                        // TODO handle jquery
                        // $('#saveCloseBtn').hide()
                    }
                    const { newInstances, metaTemplateInst } = formHelp.deserialize(
                        metaSection,
                        response.data.FormFields
                    )
                    newInstances.forEach((instance) => {
                        instance.fields?.sort(
                            (a: { displayOrder: number }, b: { displayOrder: number }) => {
                                return a.displayOrder - b.displayOrder
                            }
                        )
                    })

                    const tempFormSchema: FormSchemaMetaData = JSON.parse(
                        JSON.stringify(formState.schema)
                    )
                    // Need to update schema with the new section fields added to metaTemplateInst in deserialize
                    // TODO: handle this update in a better way, this is based on a hack in the old code
                    tempFormSchema.sections[0].instances[0] = metaTemplateInst
                    formDispatch({
                        type: FormActionKind.setSchema,
                        payload: tempFormSchema,
                    })
                    formSection.instances = newInstances

                    fieldDispatch({
                        type: FormActionKind.setFieldInstances,
                        payload: formSection.instances,
                    })

                    setOldFormData(JSON.parse(JSON.stringify(newInstances[0].fields)))

                    if (response.data != null) {
                        formDispatch({
                            type: FormActionKind.setLockedData,
                            payload: response.data,
                        })
                        let localLockedData = response.data
                        let tempInfo =
                            Cookies.get('SingletonFormsInfo') !== undefined
                                ? JSON.parse(Cookies.get('SingletonFormsInfo') || '{}')
                                : {}
                        if (
                            localLockedData.IsSingleton &&
                            tempInfo != undefined &&
                            tempInfo != null &&
                            tempInfo[localLockedData.FormName.toLowerCase()].dataObjectId !=
                                dataObjectId
                        ) {
                            //FP-5973 added check of IsSingleton
                            let customMessage =
                                'Another form is already open in a separate tab. Please close that form and click on Refresh to access this form.'
                            let msg = customMessage
                            setPopUpInfo('Alert', msg, true, -1, [
                                {
                                    text: 'Refresh',
                                    onClick: () => {
                                        location.reload()
                                    },
                                },
                            ])
                            setShowPopupMessage(true)
                        } else if (
                            localLockedData.IsSingleton &&
                            tempInfo != undefined &&
                            tempInfo != null &&
                            tempInfo[localLockedData.FormName.toLowerCase()].dataObjectId ==
                                dataObjectId &&
                            tempInfo[localLockedData.FormName.toLowerCase()].Count > 1
                        ) {
                            //FP-5973 check for is form already opened or not
                            setPopUpInfo('Alert', 'This form is already open', true, 5000, [])
                            setShowPopupMessage(true)

                            setTimeout(function () {
                                let ww = window.open(location, '_self')
                                ww.close()
                            }, 5000)
                        }

                        updateLockedStatus(localLockedData, dataObjectId)
                    } else {
                        formDispatch({
                            type: FormActionKind.setLockedStatus,
                            payload: false,
                        })
                    }
                    // TODO handleJquery
                    // UnicornApp.waitUntil(

                    //     (_: any) => $('#updateSectionScroll>.card>div').length > 0,
                    //     {}
                    // ).then((_: any) => {
                    //     if (response.data != null) {
                    //         setLockedData(response.data)
                    //         if (
                    //             (lockedData.formLocked && !isReadOnly) ||
                    //             (!lockedData.isGlobal && !isReadOnly)
                    //         ) {
                    //             //FP-8837 Adding !schemataFormMap.IsGlobal condition in or because implementing remove lock from peerreview form using isGlobal check if form is not global then we will make it accessible to everyone..
                    //             $('input').prop('disabled', false)
                    //             $('textarea').prop('disabled', false)
                    //             $('.main').removeClass('disabled')
                    //             $('select').prop('disabled', false)
                    //             $('.card.main a').css('color', '#1F75CC')
                    //             $('#FormStatus').show()
                    //         } else {
                    //             $('textarea').prop('disabled', true)
                    //             $('input:not(#color_theme_toggle_checkbox)').prop(
                    //                 'disabled',
                    //                 true
                    //             )
                    //             $('.main').addClass('disabled')
                    //             $('select').prop('disabled', true)
                    //             $('.card.main a').css('color', 'gray')
                    //             $('#FormStatus').hide()
                    //         }
                    //     } else {
                    // formDispatch({
                    //     type: FormActionKind.setLockedStatus,
                    //     payload: false,
                    // });
                    //     }
                    // })
                    // formSection.sectionId = 1
                    // formSection.loaded = true
                } else {
                    console.error(
                        '*ERR* Failed getting section ' + '. Server said, ' + response.statusMessage
                    )
                }
            },
        })
    }

    // =================== End Session Info =====================================================

    // ================================== Get section data=====================================================
    // const currentFormCount = () => {
    //     // TODO get this from appsettings
    //     const formExpirationTime = appSettings.formsLockTimeOut
    //     const counter = Math.round(
    //         formExpirationTime * 60 -
    //             Math.abs((Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) / 1000)
    //     )
    //     return counter
    // }
    const getFormData = () => {
        FoundationsRequest('POST', {
            url: getBaseUrl() + 'API/v3/FORMENGINE/CheckOrGetForm',
            cache: false,
            includeTokenHeader: true,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            data: JSON.stringify({
                FormName: formName,
                dataObjectId: formState.dataObjectId,
                guid: formState.guid ? formState.guid : -1,
            }),
            success: function (res: {
                data: {
                    formExists: boolean | ((prevState: boolean) => boolean)
                    AdditionalJsFiles: any
                }
            }) {
                const additionalJsFiles = res.data.AdditionalJsFiles
                setFormExists(res.data.formExists ? res.data.formExists : false)

                if (additionalJsFiles) {
                    additionalJsFiles.forEach((jsFile: string) => {
                        if (jsFile != '') {
                            // Make sure that scripts are only loaded once
                            // remove any existing scripts to make sure that they reload

                            // TODO handle version code
                            const newURL =
                                jsFile.replace('~', getBaseUrl()) + '?v=' + window.versionCode // whatever url you want here
                            addJsScriptSync(newURL)

                            // TODO handle this below
                            // $('head').find('script').filter(function(){
                            //     return ($(this).attr('src') && (((<any>$(this).attr('src')).includes(filePathParts[filePathParts.length-1]))));
                            // }).remove();
                        }
                    })
                }
            },
            error: (error: any) => {
                console.error(error)
                setLoading(false)
                setFormExists(false)
                FoundationsGenericToaster('error', 'Error fetching form')
            },
        })
    }
    const getDataContext = () => {
        const formType = metaFormName,
            hindex = formState.dataObjectId?.indexOf('#section')
        if (hindex !== undefined && hindex > 0) {
            formDispatch({
                type: FormActionKind.setDataObjectId,
                payload: formState.dataObjectId?.substring(0, hindex),
            })
        }
        return {
            formType: formType,
            dataObjectId: formState.dataObjectId,
        }
    }
    const getReportStatus = (dataObjectId: string) => {
        // TODO set xhr headers for api call
        let endpointUrl = getBaseUrl() + 'API/v3/FORMENGINE/STATUS'
        FoundationsRequest('GET', {
            url: endpointUrl,
            includeTokenHeader: true,
            headers: {
                dataObjectId: dataObjectId,
                formName: formName,
            },
            success: (resp: { statusCode: any; data: any }) => {
                let stat = resp.statusCode
                if (stat === 200) {
                    let data = resp.data
                    setPdfName(data.PDFName)
                    let prevStatus = statusId
                    setStatusId(data.StatusId)
                    setReportStatus(data.ReportStatus || 'Unknown')
                    setLastUpdatedBy(data.LastUpdatedBy)
                    setLastUpdatedOn(data.LastUpdatedOn)

                    formDispatch({
                        type: FormActionKind.setIsReadOnly,
                        payload: data.IsReadOnly,
                    })

                    if (prevStatus > -99 && data.StatusId != prevStatus) {
                        location.reload()
                    }
                } else {
                    console.error('*ERR* Form Status not available. Resp code=' + stat)
                }
            },
        })
    }
    const GetReadOnlySections = () => {
        setReadOnlySectionApiCallCount(readOnlySectionApiCallCount + 1)
        // TODO !! is the paylaod and resposne correct for ReadOnlySections?
        FoundationsRequest('POST', {
            url: getBaseUrl() + 'API/v3/FORMENGINE/ReadOnlySections/',
            cache: false,
            includeTokenHeader: true,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            data: JSON.stringify({
                key: formState.dataObjectId,
                formName: formName,
                guid: formState.guid ? formState.guid : -1,
            }),
            success: function (resp: { statusCode: number; data: any }) {
                var stat = resp.statusCode
                if (resp.statusCode == 201) {
                    //clear Layout divs
                    var data = resp.data
                    formDispatch({
                        type: FormActionKind.setOCVData,
                        payload: data.ocvData,
                    })

                    const objectData = data.ocvData
                    setCenterTableList([])
                    setLeftTableList([])
                    setButtonList([])

                    const tempLeftList = []
                    const tempCenterList = []
                    const tempButtonList = []

                    for (let j in objectData.item0) {
                        if (j == '0') continue
                        const val = objectData.item0[j].t
                        const layout = JSON.parse(objectData.item1[0][val]).LayoutHint
                        const render = JSON.parse(objectData.item1[0][val]).Render
                        const color = JSON.parse(objectData.item1[0][val]).Color
                        const ajaxOpts = JSON.parse(objectData.item1[0][val]).ajaxOpts
                        const collapsed = JSON.parse(objectData.item1[0][val]).isCollapsed
                        const highlightPhrases =
                            JSON.parse(objectData.item1[0][val]).Highlight == null
                                ? ''
                                : JSON.parse(objectData.item1[0][val]).Highlight
                        const lauoutObj = {
                            component: objectData['item' + (parseInt(j) + 1).toString()],
                            layout: layout,
                            render: render,
                            color: color,
                            ajaxOpts: ajaxOpts,
                            highlightPhrases: highlightPhrases,
                        }
                        if (formName.startsWith('PR')) {
                            // TODO !! handle PR code
                            // PR.handleReadOnlySections(layout, lauoutObj);
                        }
                        switch (layout) {
                            case 'banner':
                                setBannerObj(lauoutObj)
                                break
                            case 'table':
                                if (render == 'left') {
                                    tempLeftList.push({
                                        type: 'table',
                                        fixed: false,
                                        lauoutObj: lauoutObj,
                                        objectData: objectData,
                                        collapsed: collapsed,
                                        j_index: j,
                                    })
                                } else if (render == 'center') {
                                    tempCenterList.push({
                                        type: 'table',
                                        fixed: false,
                                        lauoutObj: lauoutObj,
                                        objectData: objectData,
                                        collapsed: collapsed,
                                        j_index: j,
                                    })
                                }
                                break
                            case 'fixedtable':
                                if (render == 'left') {
                                    tempLeftList.push({
                                        type: 'table',
                                        fixed: true,
                                        lauoutObj: lauoutObj,
                                        objectData: objectData,
                                        collapsed: collapsed,
                                        j_index: j,
                                    })
                                } else if (render == 'center') {
                                    tempCenterList.push({
                                        type: 'table',
                                        fixed: true,
                                        lauoutObj: lauoutObj,
                                        objectData: objectData,
                                        collapsed: collapsed,
                                        j_index: j,
                                    })
                                }
                                break
                            case 'list':
                                tempCenterList.push({
                                    type: 'list',
                                    lauoutObj: lauoutObj,
                                    objectData: objectData,
                                    j_index: j,
                                })
                                break
                            case 'API':
                                // TODO verify that the API function is correctly parsing functions
                                API(lauoutObj)
                                break
                            case 'buttons':
                                tempButtonList.push({
                                    lauoutObj: lauoutObj,
                                })
                                break
                            case 'header':
                                setHeaderObj(lauoutObj)
                                break
                            case 'barcode':
                                setBarCodeObj(lauoutObj)
                                break
                            default:
                        }
                        // TODO !! default tables to either collapsed or not collapsed
                        // $(".layout_table:not(.collapsed)").accordion({
                        //     collapsible: true
                        // });
                        // $(".layout_table.collapsed").accordion({
                        //     collapsible: true,
                        //     active: false
                        // });
                    }
                    setCenterTableList(tempCenterList)
                    setLeftTableList(tempLeftList)
                    setButtonList(tempButtonList)
                    setIsReadonlySectionLoaded(true)
                } else {
                    console.error('*ERR* OCV Response Not Available. Resp code=' + stat)
                }
            },
        })
    }
    // =============================== End Get section data=====================================================

    // =============================== Save Data =====================================================
    const signReport = useCallback(
        function (buttonData: { [s: string]: any }) {
            setStatusId(buttonData.dataStatus)
            setTimeout(function () {
                saveFormData('status', buttonData)
            }, 50)
        },
        [fieldState.fieldInstances, commentsAudit, formComments, highlightComment]
    )

    const processFormFields = function () {
        const formFields: { [s: string]: any }[] = []
        const formFieldObj = {
            FieldId: -1,
            FieldDatatype: null,
            FieldOutputType: null,
            FieldName: [],
            FieldValue: [],
            FieldIndex: [],
            fileData: []
        }
        let isrequired_fieldempty = false

        // TODO find a way to pass this through something other than window
        setCommentsAudit('')

        //TODO handle jquery style changes
        // $('.field-validation-error').remove();
        // $('.col-md-7[isrequired]').css('border', '');

        if (fieldState.fieldInstances !== undefined) {
            fieldState.fieldInstances[0].fields.forEach(function (field: {
                id: string
                fieldValue: any[]
                name: string
                type: any
                required: any
                audit: boolean
                fieldDatatype?: string
                fileData?: any
            }) {
                var fromObj = {
                    id: field.id,
                    fieldValue: field.fieldValue,
                    name: field.name,
                    type: field.type,
                    fieldDatatype: field.fieldDatatype
                }

                var newFieldObj: { [s: string]: any } = JSON.parse(JSON.stringify(formFieldObj))
                if (!!parseInt(fromObj.id)) {
                    newFieldObj.FieldId = parseInt(fromObj.id)
                    newFieldObj.FieldName.push(fromObj.name)
                    newFieldObj.FieldDatatype = fromObj.type;
                    if (fromObj.type.toLowerCase() === 'file') {
                        // Handle file input
                        var fileInput = document.getElementById('file' + fromObj.id);
                        if (field.fileData && field.fileData.length > 0) {
                            let file = field.fileData[0];
                            newFieldObj.FieldValue = [];
                        }
                        else if (fromObj.fieldValue && fromObj.fieldValue.length > 0){
                            newFieldObj.FieldValue = fromObj.fieldValue;
                        }
                    } else if (
                        fromObj.fieldValue.length > 0 &&
                        fromObj.fieldValue[0] !== '' &&
                        fromObj.fieldValue[0] !== undefined &&
                        fromObj.fieldValue[0] !== null &&
                        fromObj.fieldValue[0] !== 'Unknown'
                    ) {
                        if (fromObj.type == 'text' || fromObj.type == 'textarea') {
                            fromObj.fieldValue[0] = fromObj.fieldValue[0].trim()
                        }
                        newFieldObj.FieldValue = fromObj.fieldValue
                    } else if (field.required) {
                        isrequired_fieldempty = true
                    }

                    formFields.push(newFieldObj)
                }
                //Auditing if audit = true

                var auditFieldMessage = ''
                oldFormData.forEach(function (oldObj: { [s: string]: any }) {
                    if (
                        field.audit == true &&
                        field.id == oldObj.id &&
                        !formHelp.arraysEqual(field.fieldValue, oldObj.fieldValue)
                    ) {
                        //FP-9240 Adding extra checks for empty or unknown fieldvalue
                        var oldValue =
                            (typeof oldObj.fieldValue === 'string' && oldObj.fieldValue == '') ||
                            (Array.isArray(oldObj.fieldValue) && oldObj.fieldValue.length == 0) ||
                            (Array.isArray(oldObj.fieldValue) &&
                                oldObj.fieldValue.length > 0 &&
                                oldObj.fieldValue[0] == 'Unknown')
                                ? 'Unknown'
                                : oldObj.fieldValue
                        var newValue =
                            (typeof field.fieldValue === 'string' && field.fieldValue == '') ||
                            (Array.isArray(field.fieldValue) && field.fieldValue.length == 0) ||
                            (Array.isArray(field.fieldValue) &&
                                field.fieldValue.length > 0 &&
                                field.fieldValue[0] == 'Unknown')
                                ? 'Unknown'
                                : field.fieldValue
                        //FP-9240 If old value and new value is unknown means nothing changed so no need to audit that widget.
                        if (oldValue !== 'Unknown' || newValue !== 'Unknown') {
                            auditFieldMessage =
                                ' Changed ' +
                                field.name +
                                ' from ' +
                                oldValue +
                                ' to ' +
                                newValue +
                                ' .'
                            setCommentsAudit(commentsAudit + ' ' + auditFieldMessage)
                        }
                    }
                })
            })
        }

        if (isrequired_fieldempty) {
            return undefined
        }

        if (commentsAudit.trim() != '') {
            setCommentsAudit(' * ' + commentsAudit)
        }
        return formFields
    }
    const saveFormData = function (btnClicked: string, buttonData: { [s: string]: any } | null) {
        formDispatch({
            type: FormActionKind.setIsSaved,
            payload: true
        })
        let formFields = processFormFields()
        if (formFields == undefined || formFields == null || formFields.length < 0) return
        // TODO !! handle loading state here
        // $("#save_text").html('Saving ...');
        // $(".statusButton").css("pointer-events", "none");
        // $(".statusButton").find('span').css("background", "gray");
        setSaveText('Saving ...')
        let comment = formComments
        comment = comment + ' ' + commentsAudit
        let newStatus = buttonData ? buttonData.dataStatus + '' : statusId + ''
        let newStatusVal = buttonData ? buttonData.dataStatusVal : ''
        let workflowProcName = buttonData ? buttonData.dataProcName : 'Forms_WorkFlow_Default'
        let endpointUrl: string = getBaseUrl() + 'API/v3/FORMENGINE/PostFormData'
        let pattern = /^\s*$/
        let postformData = {
            dataObjectId: formState.dataObjectId,
            formName: formName,
            formStatus: newStatus,
            formStatusVal: newStatusVal.toLowerCase(),
            formComment: comment.replace(/[\n\r]+/g, ' '),
            workflowProcName: workflowProcName,
            btnClicked: btnClicked,
            formFields: formFields,
            formType: formState.templateType,
            commentHighlight: false,
        }
        if (pattern.test(comment)) {
            postformData.commentHighlight = false
        } else {
            postformData.commentHighlight = highlightComment
        }
        if (btnClicked == 'save_close') postformData.btnClicked = 'save'
        const formData = new FormData();
        let fieldFiles = fieldState.fieldFiles || {}    
        // Check if there are files to upload
        formData.append('postObj', JSON.stringify(postformData));
        postformData.formFields.forEach(function (field) {
            if (field.FieldDatatype && field.FieldDatatype.toLowerCase() === 'file') {
                if (fieldFiles[field.FieldId]) {
                    formData.append('file' + field.FieldId, fieldFiles[field.FieldId]); // Append the file
                }
            }
        })  

        FoundationsRequest('POST', {
            url: endpointUrl,
            data: formData,
            includeTokenHeader: true,
            success: function (response: { statusCode: number; statusMessage: string }) {
                try {
                    if (response.statusCode === 200) {
                        //$app_ajax_page_message_popup.html("Form Saved Successfully!!");

                        setSaveText('Saved ✓')
                        setTimeout(function () {
                            setSaveText('Save')
                        }, 1500)

                        // TODO handle style chagnes here
                        // $(".statusButton").find('span').attr("style", "");
                        // $(".statusButton").css("pointer-events", "auto");
                        // $(".statusButton .app-button-disabled").css("background", "gray");

                        setOldFormData(
                            JSON.parse(
                                JSON.stringify(formState.schema?.sections[0].instances[0].fields)
                            )
                        )
                        //App.Foundations.simpleTextFormDisplay();
                        if (btnClicked == 'save') {
                            //Re-Populate readOnly sections
                            GetReadOnlySections()
                            setFormComments('')
                        } else if (btnClicked == 'save_close') {
                            setFormComments('')
                            sessionStorage.removeItem(`_drillThruObj_${formState.dataObjectId}`)
                            formDispatch({
                                type: FormActionKind.setLockedStatus,
                                payload: false,
                            })
                            if (formState.lockedData?.isGlobal) {
                                checkOrGetLock()
                            } else {
                                console.error('Does this look right? formState.lockedData was:')
                                console.error(formState.lockedData)
                            }
                            if (
                                formState.isNavigationEnabled == 'true' &&
                                !formState.isCopyPasted
                            ) {
                                setPopUpInfo(
                                    'Form Navigation Alert',
                                    'Searching for next available form',
                                    false,
                                    -1,
                                    []
                                )
                                setShowPopupMessage(true)
                                let _drillThruParams = ''

                                if (drillThruObjRef.current == undefined) {
                                    FoundationsGenericToaster('error', 'Form data missing')
                                } else {
                                    _drillThruParams = toBinary(
                                        JSON.stringify(drillThruObjRef.current)
                                    )
                                    formNavigation.navigateThroughWorklist(
                                        {
                                            direction: 'forward',
                                            drillthruObj: _drillThruParams,
                                            columnsData: drillThruObjRef.current?.columnsData,
                                        },
                                        formName,
                                        formState.dataObjectId,
                                        setTabGuid,
                                        (obj: any) => {
                                            drillThruObjRef.current = obj
                                        },
                                        setPopUpInfo,
                                        setShowPopupMessage
                                    )
                                }
                            } else {
                                formDispatch({
                                    type: FormActionKind.setLockedStatus,
                                    payload: false,
                                })
                                setTimeout(function () {
                                    let ww = window.open(location, '_self')
                                    ww.close()
                                }, 10)
                            }
                        } else {
                            formHelp.unlockForm(
                                formName,
                                formState.dataObjectId,
                                formState.isNavigationEnabled,
                                !!formState.isCopyPasted,
                                'NO',
                                drillThruObjRef.current || {},
                                setTabGuid,
                                (obj: any) => {
                                    drillThruObjRef.current = obj
                                },
                                setPopUpInfo,
                                setShowPopupMessage
                            )
                        }
                    } else {
                        console.error(
                            '*ERR* Failed saving data : ' +
                                '. Server said, ' +
                                response.statusMessage
                        )
                        setPopUpInfo('Error', 'Saving form failed!', false, -1, [])
                        setShowPopupMessage(true)
                    }
                } catch (ex) {
                    console.error('*ERR Exception* Failed saving : Exception was ' + ex)
                    setPopUpInfo('Error', 'Saving form failed!', false, -1, [])
                    setShowPopupMessage(true)
                }
            },
        })
    }

    const saveData = useCallback(() => {
        saveFormData('save', null)
    }, [fieldState, formState, highlightComment, statusId, formComments, formName])

    const saveCloseData = useCallback(() => {
        saveFormData('save_close', null)
    }, [fieldState, formState, highlightComment, statusId, formComments, formName])
    // =============================== End Save Data =====================================================
    const formChannelRef = useRef(null as null | BroadcastChannel)
    useEffect(() => {
        setCommentsAudit('')
        // subvizlist appears to not be used, always hardcoded to true
        // let newSubVizList = new Array(42)
        // newSubVizList = newSubVizList.map((_) => true)
        // setSubVizList(newSubVizList)
        formDispatch({
            type: FormActionKind.setIsCopyPasted,
            payload: JSON.parse(sessionStorage.getItem('isCopyPasted') || 'false'),
        })

        const hindex = document.location.href.indexOf('#section')
        setHindex(hindex > 0 ? parseInt(document.location.href.substring(hindex + 8), 10) - 1 : 0)

        // TODO: Find a better way to handle this instead of waiting for the js file to load
        // TODO: take timestamp from appsettings properly
        addJsScriptSync(
            getBaseUrl() +
                'FormsEngine/FormSchemaFiles/' +
                formName +
                '.js?v=' +
                appSettings?.FormsLastGeneratedTimeStamp,
            formName + '_script'
        )

        let count = 0
        const loadScriptInterval = setInterval(() => {
            if (window.schemataFormMap !== undefined) {
                clearInterval(loadScriptInterval)
                // const schemataMap = window.schemataFormMap?.schemataMap
                // formDispatch({
                //     type: FormActionKind.setSchema,
                //     payload: schemataMap[window.schemataFormMap?.templateType][metaFormName],
                // })
                formDispatch({
                    type: FormActionKind.setTemplateType,
                    payload: window.schemataFormMap?.templateType || '',
                })
                formDispatch({
                    type: FormActionKind.setMetaDataMap,
                    payload: window.schemataFormMap?.MetaDataMap || {},
                })
                formDispatch({
                    type: FormActionKind.setValidatorMetaMap,
                    payload: window.schemataFormMap?.validatorMetaMap || {},
                })
            } else if (count > 5) {
                clearInterval(loadScriptInterval)
                FoundationsGenericToaster('error', 'Form schema did not load')
            } else {
                count++
            }
        }, 400)
        // let unicornassuranceHandler: string | number | NodeJS.Timeout | undefined

        const storeDrillThruData = () => {
            const deepLinkURL = toBinary(JSON.stringify(drillThruObjRef.current))
            setCookie('drillthrudata_' + globalTabGuidRef.current, deepLinkURL, 0.5)
        }

        formChannelRef.current = new BroadcastChannel('form-data-' + window.location.href)
        formChannelRef.current.addEventListener(
            'message',
            function (e) {
                // unicornassuranceHandler = setInterval(function () {
                try {
                    drillThruObjRef.current = JSON.parse(formHelp.fromBinary(e.data))
                    sessionStorage.setItem(
                        `_drillThruObj_${formState.dataObjectId}`,
                        JSON.stringify(JSON.parse(formHelp.fromBinary(e.data)))
                    )
                    // TODO handle resetgin header
                    // resetHeaders();
                    // For some reason the marioneete onbeforeunload will not trigger, so manually
                    window.addEventListener('beforeunload', storeDrillThruData)

                    // setTimeout(function () {
                    //     window.helpermethods.updateeveryinterval()
                    //     //window.helpermethods.displayelement("completionpercentagedial");
                    //     //$("#page-loading").hide();
                    // }, 2000)

                    // ============================================================== TODO ==================================================
                    // $(function () {
                    //     (<any>$("#dialog")).dialog({
                    //         autoOpen: false, modal: true, show: "blind", hide: "blind", width: 440,
                    //             });
                    //         });
                    //         /**
                    //         * This function hides the form actions dropdown menu when the save now button is clicked(the window is also clicked)
                    //         * The setTimeout for the interval is so that the completion percentage dial has time before it loads otherwise some fields may not have yet loaded.
                    //         * */
                    //         window.onclick = function () {
                    //             //healthLevelWorkspace.hideAllLists();
                    //             setTimeout(function () { window.helpermethods.updateeveryinterval(); }, 20);
                    //         }
                    //         window.onkeyup = function () { window.helpermethods.updateeveryinterval(); };
                    // ============================================================== END TODO ==================================================

                    // clearInterval(unicornassuranceHandler)
                } catch (ex) {
                    console.error(ex)
                }
                // }, 500)
                formChannelRef.current?.close()
            },
            false
        )
        formChannelRef.current?.postMessage('form-ready')
        getFormData()

        // Handle component unmounting logic
        return () => {
            clearInterval(loadScriptInterval)
            // if (sessionInterval.current !== null) clearInterval(sessionInterval.current)
            formChannelRef.current?.close()
            // clearInterval(unicornassuranceHandler)
            window.removeEventListener('beforeunload', storeDrillThruData)
        }
    }, [])
    useEffect(() => {
        if (formExists) {
            formDispatch({ type: FormActionKind.setTabGuid, payload: formState.tabGuid })

            // TODO remove all window references
            globalTabGuidRef.current = formState.tabGuid
            formDispatch({
                type: FormActionKind.setIsNavigationEnabled,
                payload: getUrlVars()['navigationenabled'],
            })

            if (formState.isNavigationEnabled === undefined) {
                formDispatch({ type: FormActionKind.setIsNavigationEnabled, payload: 'false' })
            }

            //_drillThruParams = "";
            let _drillThruParams = getUrlVars()['drillThruParams']
            // TODO globalTabguid and window._drillthru should be passed through the store no the window object
            _drillThruParams = Cookies.get('drillthrudata_' + globalTabGuidRef.current)
            setCookie('drillthrudata_' + globalTabGuidRef.current, '', -15)
            let tempDrillThruObj = drillThruObjRef.current
            if (drillThruObjRef.current === undefined) {
                tempDrillThruObj =
                    _drillThruParams != null
                        ? JSON.parse(formHelp.fromBinary(_drillThruParams))
                        : drillThruObjRef.current == null
                          ? JSON.parse(
                                sessionStorage.getItem(
                                    `_drillThruObj_${formState.dataObjectId}`
                                ) as string
                            )
                          : drillThruObjRef.current
                drillThruObjRef.current = tempDrillThruObj
            }
            // sessionStorage.setItem(
            //     `_drillThruObj_${formState.dataObjectId}`,
            //     JSON.stringify(drillThruObjRef.current)
            // )

            // TODO
            // resetHeaders();

            // get all securities

            //The completion percentage dial cannot be activated immediately after the page loads because the data in the form has not yet loaded, thus, we need to wait some time for that data to load then we can call it.
            //1700 milliseconds seems to be the lower limit but this is kept at 2000 milliseconds to be sure that all the data loads.
            // TODO what data needs to be regularly updated and how to update it?
            // setTimeout(function () {
            // window.helpermethods.updateeveryinterval()
            //$("#page-loading").hide();
            // }, 2000)

            //This function initializes the dialog box without opening it
            // $(function () {
            // TODO add dialog call?
            // ($("#dialog")).dialog({
            //     autoOpen: false, modal: true, show: "blind", hide: "blind", width: 440,
            // });
            // })
            /**
             * This function hides the form actions dropdown menu when the save now button is clicked(the window is also clicked)
             * The setTimeout for the interval is so that the completion percentage dial has time before it loads otherwise some fields may not have yet loaded.
             * */
            // window.onclick = function () {
            //     //healthLevelWorkspace.hideAllLists();
            //     setTimeout(function () {
            //         window.helpermethods.updateeveryinterval()
            //     }, 20)
            // }
            // window.onkeyup = function () {
            //     window.helpermethods.updateeveryinterval()
            // }

            /**
             * Before printing, remove the sticky property of the header to make sure it doesn't overlap with other parts of the header
             * */
            // TODO handle print styling here
            // window.onbeforeprint = function () {
            //     header?.classList.remove("sticky");
            //     section?.classList.remove("sectionLeft");
            // }
        }
    }, [formExists])
    // useEffect(() => {
    //     // TODO handle form countdown!!!
    //     if (formCounter >= 0) {
    //         console.error('need to handle form countdown')
    //         if (sessionStorage.getItem('formLockGuid') != undefined) {
    //             if (!formState.lockedStatus){
    //                 formDispatch({
    //                     type: FormActionKind.setLockedStatus,
    //                     payload: true,
    //                 })
    //             }
    //             const counter = currentFormCount()
    //             const extendSession =
    //                 Math.round(Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION)) / 1000) >=
    //                 Math.round(Number(Date.now() / 1000))
    //             if (isFormLocked.current && extendSession) {
    //                 isFormLocked.current = false
    //                 extendFormSession(false, false)
    //             }

    //             if (counter <= 30) {
    //                 isFormLocked.current = true
    //                 if (Cookies.get(FoundationsConstants.LAST_USER_INTERACTION)) {
    //                     if (timerToastId.current === null) {
    //                         timerToastId.current = (
    //                             FoundationsGenericToaster(
    //                                 'error',
    //                                 formHelp.getFormsPopupMessageCounter(counter)
    //                             )
    //                         )
    //                     } else {
    //                         toast.update(timerToastId.current, {
    //                             render: formHelp.getFormsPopupMessageCounter(counter),
    //                             type: 'error',
    //                         })
    //                     }
    //                 }
    //                 // TODO get this from appSettings
    //                 const formExpirationTime = appSettings.formsLockTimeOut
    //                 let idleAllowedTime = (formExpirationTime - 2) * 60
    //                 if (
    //                     !Cookies.get(FoundationsConstants.LAST_USER_INTERACTION) ||
    //                     Math.abs(
    //                         (Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) / 1000
    //                     ) < idleAllowedTime
    //                 ) {
    //                     FoundationsGenericToaster('clear')
    //                     setFormCounter(-1)
    //                 } else {
    //                     const counter = Math.round(
    //                         formExpirationTime * 60 -
    //                             Math.abs(
    //                                 (Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) /
    //                                     1000
    //                             )
    //                     )
    //                     if (
    //                         Math.abs(
    //                             (Date.now() - Number(Cookies.get(FoundationsConstants.LAST_USER_INTERACTION))) / 1000
    //                         ) >
    //                         formExpirationTime * 60 - 5
    //                     ) {
    //                         FoundationsGenericToaster('clear')
    //                         setFormCounter(-1)
    //                         let customMessage = ''
    //                         let autoNav = false
    //                         if (
    //                             formState.isNavigationEnabled == 'true' &&
    //                             !formState.isCopyPasted
    //                         ) {
    //                             customMessage =
    //                                 'Click OK to re-lock this form (if not yet locked by another user) or to navigate to the next available form.'
    //                             autoNav = true
    //                         } else {
    //                             customMessage =
    //                                 'Click OK to re-lock this form (if not yet locked by another user). Otherwise it will load as read-only.'
    //                             autoNav = false
    //                         }
    //                         let msg = customMessage
    //                         formDispatch({
    //                             type: FormActionKind.setLockedStatus,
    //                             payload: false,
    //                         })
    //                         checkOrGetLock()
    //                         setPopUpInfo('Form Time out', msg, true, -1, [
    //                             {
    //                                 text: 'OK',
    //                                 onClick: () => {
    //                                     extendFormSession(true, autoNav)
    //                                 },
    //                             },
    //                         ])
    //                         setShowPopupMessage(true)
    //                     } else {
    //                         // TODO !! handle toastr window
    //                         if (!timerToastId.current) {
    //                             timerToastId.current = (
    //                                 FoundationsGenericToaster(
    //                                     'error',
    //                                     formHelp.getFormsPopupMessageCounter(counter)
    //                                 )
    //                             )
    //                         } else {
    //                             if (timerToastId.current !== null) {
    //                                 toast.update(timerToastId.current, {
    //                                     render: formHelp.getFormsPopupMessageCounter(counter),
    //                                     type: 'error',
    //                                 })
    //                             }
    //                         }
    //                     }
    //                 }
    //             }
    //             setFormCounter(counter)
    //         }
    //     } else {
    //         setFormCounter(-1)
    //         timerToastId.current = null
    //     }
    // }, [startTimer, formCounter])

    useEffect(() => {
        // TODO !! handle any changes from formSTate.form here
        if (Object.keys(formState.schema).length !== 0 && !sectionDetailsLoaded) {
            const dataContext = getDataContext()
            try {
                getReportStatus(dataContext.dataObjectId)
            } catch (ex) {
                console.error(ex)
            }
        }
    }, [formState.schema])

    useEffect(() => {
        if (reportStatus !== undefined && reportStatus !== '') {
            const dataContext = getDataContext()
            getSectionDetails(dataContext.dataObjectId)
            if (!isReadonlySectionLoaded && readOnlySectionApiCallCount == 0) {
                GetReadOnlySections()
            }
        }
    }, [reportStatus])

    useEffect(() => {
        if (formState.templateType !== '' && formExists) {
            // TODO move getfeaturesecuritylist to react
            window.healthLevelGlobal.getFeatureSecurityList().then(function (successVal: any) {
                let allowedSecurities: string[] = successVal
                const tempFormActions = JSON.parse(JSON.stringify(formActions))
                Object.keys(formActions).forEach(function (value) {
                    if (allowedSecurities.includes(value)) {
                        tempFormActions[value] = true
                    }
                    setFormActions(tempFormActions)
                })
            })
        }
    }, [formExists, formState.templateType])

    useEffect(() => {
        if (formState.templateType !== '' && formExists && currentUserData !== undefined) {
            signin()
        }
    }, [formActions, currentUserData])

    useEffect(() => {
        if (formState.lockedData !== undefined && formState.dataObjectId !== undefined) {
            updateLockedStatus(formState.lockedData, formState.dataObjectId)
        }
    }, [formState.isReadOnly])

    const formLockPopUp = () => {
        if (timerToastId.current !== null) toast.dismiss(timerToastId.current)
        // if (sessionInterval.current !== null) clearInterval(sessionInterval.current)
        var customMessage = ''
        var autoNav = false
        if (formState.isNavigationEnabled == 'true' && !formState.isCopyPasted) {
            customMessage =
                'Click OK to re-lock this form (if not yet locked by another user) or to navigate to the next available form.'
            autoNav = true
        } else {
            customMessage =
                'Click OK to re-lock this form (if not yet locked by another user). Otherwise it will load as read-only.'
            autoNav = false
        }
        var msg = customMessage
        formDispatch({
            type: FormActionKind.setLockedStatus,
            payload: false,
        })
        checkOrGetLock()
        setPopUpInfo('Form Time Out', msg, false, -1, [
            {
                text: 'ok',
                onClick: () => {
                    extendFormSession(true, autoNav)
                },
            },
        ])
        setShowPopupMessage(true)
    }

    return (
        <FormEngineContext.Provider value={formProviderState}>
            <FieldContext.Provider value={fieldProviderState}>
                <div style={{ fontSize: '14px' }} className="printHeader onlyprint">
                    Printed on: {printedOn}
                </div>
                <div className={formName}>
                    <div className="form-wrapper mt-1">
                        <div className="dashboard-wrapper">
                            <main className="hlform">
                                <div id="dashboard_data_wrapper" className="dashboard-data-wrapper">
                                    <div id="formcontent-wrapper" className="dashboard-vu-contents">
                                        {formExists && userHasPermission ? (
                                            // TODO condense down, no need to pass a massive list of props like this
                                            <MyForm
                                                key={'formFrame'}
                                                isReadonlySectionLoaded={isReadonlySectionLoaded}
                                                showEditBtn={showEditBtn}
                                                reportStatus={reportStatus}
                                                leftTableList={leftTableList}
                                                hindex={hindex}
                                                lastUpdatedBy={lastUpdatedBy}
                                                lastUpdatedOn={lastUpdatedOn}
                                                drillThruObjRef={drillThruObjRef}
                                                setDialogObject={setDialogObject}
                                                setDialogVisible={setDialogVisible}
                                                globalTabGuidRef={globalTabGuidRef}
                                                setPrintedOn={setPrintedOn}
                                                addAuditComment={addAuditComment}
                                                formComments={formComments}
                                                setFormComments={setFormComments}
                                                highlightComment={highlightComment}
                                                setHighlightComment={setHighlightComment}
                                                saveText={saveText}
                                                saveData={saveData}
                                                buttonList={buttonList}
                                                saveCloseData={saveCloseData}
                                                signReport={signReport}
                                                headerObj={headerObj}
                                                barCodeObj={barCodeObj}
                                                bannerObj={bannerObj}
                                                centerTableList={centerTableList}
                                                setPopUpInfo={setPopUpInfo}
                                                setShowPopupMessage={setShowPopupMessage}
                                            ></MyForm>
                                        ) : !loading && formExists && !userHasPermission ? (
                                            <h1 className="text-center">
                                                No permission to view this form. Please contact IT
                                                Administrator for security codes.
                                            </h1>
                                        ) : !loading ? (
                                            <h1 className="text-center">
                                                The form is not configured or is broken. Please
                                                contact the Administrator.
                                            </h1>
                                        ) : (
                                            <>
                                                <Skeleton
                                                    className="skeleton-border m-auto"
                                                    loading={loading}
                                                    height="85vh"
                                                    width="98%"
                                                ></Skeleton>
                                            </>
                                        )}
                                    </div>
                                    {dialogVisible && dialogObject && (
                                        <OCVDialog
                                            key={dialogObject.Id}
                                            clickThruElement={null}
                                            ocvType="info"
                                            launcherMode="popup"
                                            objectContext={dialogObject}
                                            onClose={() => {
                                                setDialogVisible(false)
                                            }}
                                        />
                                    )}
                                    <HandleAnyPopupMessage
                                        isOpen={showPopupMessage}
                                        title={popupTitle}
                                        message={popupMessage}
                                        onClose={() => setShowPopupMessage(false)}
                                        closeAfterSecs={closeAfterSecs}
                                        Link={null}
                                        linkText=""
                                        customButtons={customPopupButtons}
                                        hideClose={hidePopupClose}
                                        textClasses="font-weight-bold"
                                    />
                                    <span className="hide">
                                        <IdleWatcher
                                            idleTimeout={appSettings.formsLockTimeOut * 60 * 1000}
                                            idleWarning="This form times out in "
                                            onIdleCustom={() => {
                                                if (appSettings.formsLockTimeOut !== undefined)
                                                    formLockPopUp()
                                            }}
                                            warningMins={0.5}
                                        />
                                    </span>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </FieldContext.Provider>
        </FormEngineContext.Provider>
    )
}

const MyForm = (props: any) => {
    return FormFrame(Col1, Col2, Col3)(props)
}

const Col1 = React.memo(
    (props: {
        isReadonlySectionLoaded: boolean
        showEditBtn: boolean
        reportStatus: string
        leftTableList: any[]
        hindex: number
        lastUpdatedBy: string
        lastUpdatedOn: string
        drillThruObjRef: React.MutableRefObject<any>
        globalTabGuidRef: React.MutableRefObject<string>
        setPrintedOn: (s: string) => void
        setDialogObject: (s: ObjectContext) => void
        setDialogVisible: (b: boolean) => void
    }) => {
        const {
            isReadonlySectionLoaded,
            showEditBtn,
            reportStatus,
            leftTableList,
            hindex,
            lastUpdatedBy,
            lastUpdatedOn,
            drillThruObjRef,
            globalTabGuidRef,
            setPrintedOn,
            setDialogObject,
            setDialogVisible,
        } = props
        const { formState } = useFormEngineContext()
        return (
            <Skeleton className="skeleton-border" loading={!isReadonlySectionLoaded} height="85vh">
                {/* ======================================= Action Section ================================================  */}
                {formState.schema !== undefined && Object.keys(formState.schema).length !== 0 && (
                    <ActionsSection
                        index={hindex}
                        showEditBtn={showEditBtn}
                        drillThruObj={drillThruObjRef.current || {}}
                        setTabGuid={(s: string) => {
                            globalTabGuidRef.current = s
                        }}
                        setDrillThruObj={(obj: any) => {
                            drillThruObjRef.current = obj
                        }}
                        setPrintedOn={setPrintedOn}
                    />
                )}
                {/* ======================================= Form Status Section ================================================  */}
                <FormStatusCompo
                    reportStatus={reportStatus}
                    lastUpdatedBy={lastUpdatedBy}
                    lastUpdatedOn={lastUpdatedOn}
                />
                {/* ======================================= Left Tables ================================================  */}
                <LeftTables
                    leftTableList={leftTableList}
                    setDialogObject={setDialogObject}
                    setDialogVisible={setDialogVisible}
                />
            </Skeleton>
        )
    }
)

const Col2 = React.memo(
    (props: {
        isReadonlySectionLoaded: boolean
        headerObj: any
        barCodeObj: any
        bannerObj: any
        centerTableList: any[]
        setDialogObject: (obj: ObjectContext) => void
        setDialogVisible: (b: boolean) => void
    }) => {
        const {
            isReadonlySectionLoaded,
            headerObj,
            barCodeObj,
            bannerObj,
            centerTableList,
            setDialogObject,
            setDialogVisible,
        } = props
        return (
            <Skeleton className="skeleton-border" loading={!isReadonlySectionLoaded} height="85vh">
                <div className="row section-border-left flex-column h-100 overflow-visible">
                    {/* ======================================= PHI Header ================================================  */}
                    <PHIHeader
                        headerObj={headerObj}
                        setDialogObject={setDialogObject}
                        setDialogVisible={setDialogVisible}
                    />
                    <hr></hr>
                    {/* ======================================= barcode-middle ================================================  */}
                    <BarCodeSection barCodeObj={barCodeObj} bannerObj={bannerObj} />
                    {/* ======================================= Read-Only Form Section ================================================  */}
                    <ReadOnlyFormSection
                        centerTableList={centerTableList}
                        setDialogObject={setDialogObject}
                        setDialogVisible={setDialogVisible}
                    />
                </div>
            </Skeleton>
        )
    }
)

const Col3 = React.memo(
    (props: {
        addAuditComment: any
        formComments: string
        setFormComments: (s: string) => void
        highlightComment: boolean
        setHighlightComment: (b: boolean) => void
        saveText: string
        saveData: () => void
        buttonList: any[]
        saveCloseData: () => void
        signReport: (buttonData: { [s: string]: any }) => void
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void
        setShowPopupMessage: (show: boolean) => void
    }) => {
        const {
            addAuditComment,
            formComments,
            setFormComments,
            highlightComment,
            setHighlightComment,
            saveText,
            saveData,
            buttonList,
            saveCloseData,
            signReport,
            setPopUpInfo,
            setShowPopupMessage,
        } = props
        const { formState } = useFormEngineContext()
        const { fieldState } = useFieldContext()

        const formDisabled =
            (!formState.lockedData?.formLocked || formState.isReadOnly) &&
            (formState.lockedData?.isGlobal || formState.isReadOnly)
        return (
            <Skeleton
                className="skeleton-border"
                loading={
                    fieldState.fieldInstances === undefined ||
                    fieldState.fieldInstances.length === 0
                }
                height="85vh"
            >
                <div id="sections"></div>
                {/* ======================================= Widgets Section================================================  */}
                <UpdateFormSection
                    addAuditComment={addAuditComment}
                    setPopUpInfo={setPopUpInfo}
                    setShowPopupMessage={setShowPopupMessage}
                    formDisabled={formDisabled}
                />
                {/* ======================================= Update Form Section ================================================  */}
                <div
                    id="FormStatus"
                    className="mt-3"
                    style={formDisabled ? { display: 'none' } : {}}
                >
                    <div className="row mt-0">
                        <div className="col-8 col-sm-9 noprint">
                            <textarea
                                placeholder="Comments"
                                id="form-comments"
                                className="textarea"
                                rows={3}
                                maxLength={1970}
                                value={formComments}
                                onInput={(e: any) => setFormComments(e.target.value)}
                            ></textarea>
                            <span id="check_label">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="commentHighlight"
                                        name="highlight"
                                        checked={highlightComment}
                                        onChange={(e: any) => setHighlightComment(e.target.checked)}
                                    />
                                    <span className="checkable">Highlight Comment</span>
                                </label>
                            </span>
                        </div>
                        <div className="col-4 col-sm-3 text-right">
                            <div id="saveBtn">
                                <h6>
                                    <a id="save-data" className="statusButton" onClick={saveData}>
                                        <span className="label app-button">
                                            <span id="save_text">{saveText}</span>
                                        </span>
                                    </a>
                                </h6>
                            </div>
                            {!formState.isCopyPasted ? (
                                <div id="saveCloseBtn">
                                    <h6>
                                        <a
                                            id="save-close-data"
                                            className="statusButton"
                                            onClick={saveCloseData}
                                        >
                                            <span className="label app-button">
                                                <span id="save_close_text">
                                                    {formState.isNavigationEnabled == 'true' &&
                                                    !formState.isCopyPasted
                                                        ? 'Save & Next'
                                                        : 'Save & Close'}
                                                </span>
                                            </span>
                                        </a>
                                    </h6>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                    <hr />
                    <div id="buttonsDiv">
                        {buttonList.map((button, index) => {
                            return (
                                <FormButtons
                                    key={index}
                                    lauoutObj={button.lauoutObj}
                                    signReport={signReport}
                                />
                            )
                        })}
                    </div>
                </div>
            </Skeleton>
        )
    }
)

export default FormsEngine
